/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetCompositionsDetailByIdQueryResponse, GetCompositionsDetailByIdPathParams } from "../models/GetCompositionsDetailById";

export function getGetCompositionsDetailByIdUrl(id: GetCompositionsDetailByIdPathParams["id"]) {
  const res = { method: 'GET', url: `/compositions/${id}` as const }
  return res
}

/**
 * @summary Get one composition by id
 * {@link /compositions/:id}
 */
export async function getCompositionsDetailById(id: GetCompositionsDetailByIdPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetCompositionsDetailByIdQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetCompositionsDetailByIdUrl(id).url.toString(), ... requestConfig })
  return res.data
}